




import Vue, { PropType } from 'vue';
import { VFairPavilion } from '~/services/types/vfair';
import Breadcrumb, { Crumb } from '~/shared/Breadcrumb.vue';
import URLS from '~/URLS';

export default Vue.extend({
    name: 'VFairBreadcrumb',
    components: {
        Breadcrumb,
    },
    props: {
        pavilion: {
            type: Object as PropType<VFairPavilion | null>,
            default: null,
        },
    },
    data() {
        return {
            breadcrumbs: [] as Crumb[],
        };
    },
    methods: {
        async updateBreadcrumb() {
            const vFairId = this.$route.params.id;
            const vFairPath = URLS.vfairs.concat('/', vFairId);

            const crumbs: Crumb[] = [
                {
                    text: this.$t('vfair.pavilionTabs.lobby').toString(),
                    to: vFairPath,
                },
            ];

            if (!!this.pavilion) {
                const pavilionPath = URLS.vfair.concat('/', vFairId, '/', this.pavilion.id);
                crumbs.push({
                    text: this.pavilion.title,
                    to: pavilionPath,
                    active: true,
                });
            }

            this.breadcrumbs = crumbs;
        },
    },
    watch: {
        $route() {
            this.updateBreadcrumb();
        },
        pavilion() {
            this.updateBreadcrumb();
        },
    },
    mounted() {
        this.updateBreadcrumb();
    },
});
